import styled, { css } from 'styled-components';
import Screen from '@/styles/Themes/Screen';
import { cssVars } from '@/styles/Themes/cssVars';
import Palette from '@/styles/Themes/Palette';
import { radius } from '@/styles/Themes/Metrics';
import Text from '@/styles/Themes/Text/index';
import { borders } from '@/styles/Themes/Metrics';

export const BillingInfoContainer = styled.div<{ hide?: boolean }>`
    ${({ hide }) => hide && 'display: none;'}
    margin: 0;
    background-color: ${cssVars.bg_white_dark3};
    border-radius: ${radius.small};
    color: ${Palette.green.normal};
    width: 100%;
    max-width: 680px;

    .braintree-method__delete-container {
        display: none;
    }

    .braintree-dropin {
        background-color: ${cssVars.bg_white_dark3};
    }

    .braintree-heading {
        ${Text.Mobile.large.semibold};
        color: ${cssVars.fg_gray1_white};
    }

    .braintree-options-list {
        background-color: ${cssVars.bg_white_dark3};
    }

    .braintree-method {
        background-color: ${cssVars.bg_white_dark3};
        border: ${borders.small} ${cssVars.bg_gray4_dark2};
        color: ${cssVars.fg_gray1_white};
    }

    .braintree-option {
        background-color: ${cssVars.bg_white_dark3};
        height: 68px;
        border-radius: ${radius.small};
        padding: 20px;
        border: none;
        &:first-child {
            margin-top: 21px;
        }
    }

    .braintree-option {
        border-bottom: ${borders.small} ${cssVars.bg_gray4_dark2};
        border-radius: 0;
    }

    .braintree-option__label {
        color: ${cssVars.fg_gray2_gray3};
        ${Text.Mobile.medium.medium};
    }

    .braintree-card {
        background-color: ${cssVars.bg_white_dark3};
        border: none;
    }

    .braintree-large-button {
        background-color: ${cssVars.bg_white_dark3};
        color: ${cssVars.fg_gray2_gray3};
    }

    .braintree-sheet__text {
        color: ${cssVars.fg_gray1_white};
        ${Text.Full.medium.medium};
    }

    .braintree-form__field-group .braintree-form__label {
        color: ${cssVars.fg_gray1_white};
        ${Text.Full.normal.medium};
    }

    .braintree-form-number {
        border-radius: 12px;
    }

    .braintree-form__hosted-field {
        border-radius: 12px;
    }

    .braintree-sheet__header {
        border: none;
        border-bottom: ${borders.small} ${cssVars.bg_gray4_dark2};
    }

    .braintree-loader__container {
        background-color: ${cssVars.bg_white_dark3};
    }

    ${Screen.desktop} {
        margin: 0 auto;

        .braintree-heading {
            color: ${cssVars.fg_gray1_white};
            ${Text.Desktop.heading3};
            margin-bottom: 39px;
        }

        .braintree-option__label {
            ${Text.Desktop.heading4};
        }

        .braintree-option {
            height: 110px;
            padding: 30px 40px;

            &:first-child {
                margin-top: 39px;
            }

            &:hover {
                background-color: ${cssVars.bg_ash_blueDark};

                > div {
                    color: ${Palette.green.normal};
                }
            }
        }

        .braintree-form__field-group .braintree-form__label {
            ${Text.Desktop.small.medium};
        }

        .braintree-form-number {
            border-radius: ${radius.small};
        }
    }

    .braintree-show-applePay .braintree-applePay,
    .braintree-show-googlePay .braintree-googlePay,
    .braintree-show-venmo .braintree-venmo {
        display: block;
        height: auto;
        overflow: visible;
        visibility: visible;
    }

    .apple-pay-button {
        -webkit-appearance: -apple-pay-button;
        -apple-pay-button-type: plain;
    }

    box-shadow: ${cssVars.shadow_container};
`;

export const BillingInfoHeader = styled.div<{ isPaypal?: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    align-items: center;
    background-color: ${cssVars.bg_ash_blueDark};
    border-radius: 15px 15px 0 0;
    padding: 12px 12px 12px 20px;
    flex-wrap: wrap;

    ${Screen.ipad} {
        flex-wrap: nowrap;
        justify-content: space-around;
    }
`;

export const TotalText = styled.div`
    color: ${cssVars.fg_gray2_gray3};
    ${Text.Full.large.medium};
    text-align: center;

    margin-top: 20px;

    > span {
        ${Text.Full.large.semibold};
    }
`;

export const Title = styled.div`
    color: ${cssVars.fg_gray2_gray3};
    ${Text.Full.heading4};
    text-align: center;

    margin-top: 20px;
`;

export const BillingInfoTitle = styled.p`
    display: flex;
    margin: 0 0 4px;
    align-items: center;
    width: 100%;
    max-width: 198px;

    > svg {
        flex-shrink: 0;
        margin-right: 8px;
    }

    ${Screen.ipad} {
        width: auto;
        margin: 0;
    }
`;

export const BillingInfoBody = styled.div`
    padding: 24px;
    background: ${cssVars.bg_white_dark3};
    border-radius: 0 0 15px 15px;

    ${Screen.ipad} {
        padding: 30px 42px;
    }

    ${Screen.desktop} {
        padding: 40px 56px;
    }
`;

export const StripeCardContainer = styled.div`
    margin: 20px 0;
`;

export const BraintreeButton = styled.div`
    width: 280px;
    height: 50px;
    margin: 16px auto 0;

    ${Screen.desktop} {
        width: 250px;
        margin: 24px auto 0;
    }
`;

export const SubmitDescription = styled.div`
    margin: 0 auto 20px;
    font-style: italic;
    color: ${cssVars.fg_gray3_dark1};
    ${Text.Full.small.medium};
    width: fit-content;
    text-align: center;
    font-size: 10px;
    line-height: 12px;

    > a {
        text-decoration: underline;
        cursor: pointer;
        ${Text.Full.small.semibold};
        font-style: normal;
        color: ${cssVars.fg_gray2_gray3};
    }
`;

export const ParagraphWrapper = styled.div`
    height: 70vh;
    overflow-y: scroll;
`;

export const LoaderContainer = styled.div`
    width: 100%;
    height: 270px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 3;
`;

export const StripeLoader = styled.div`
    width: 100%;
    height: 270px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
`;

export const GPayBtn = styled.div<{ hide?: boolean }>`
    #gpay-button-online-api-id {
        width: 100%;
        margin-top: 4px;
        /* TODO: remove to enable GPay button */
        /* display: none; */
    }
    &:hide {
        visibility: hidden;
        height: 0;
    }
`;

export const FluidPayWrapper = styled.div<{ hide?: boolean }>`
    ${({ hide }) =>
        hide &&
        css`
            visibility: hidden;
            height: 0;
            overflow: hidden;
        `}
`;

export const RestoreGPayBtn = styled.p`
    color: ${cssVars.fg_gray2_white};

    text-decoration: underline;
    text-align: center;
    cursor: pointer;
`;

export const ImgLoader = styled.img`
    position: relative;
`;

export const StripeStyles = {
    style: {
        base: {
            color: cssVars.fg_gray2_white,
            backgroundColor: cssVars.bg_ash_blueDark,
        },
    },
};
